// MessageIcon

export const MessageIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 22C17.5229 22 22 17.5229 22 12C22 6.47715 17.5229 2 12 2C6.47715 2 2 6.47715 2 12C2 13.3558 2.26983 14.6487 2.75873 15.8277C3.01116 16.4364 3.32198 17.0149 3.68422 17.556C3.80579 17.7376 3.57771 18.8856 3 21C5.11445 20.4223 6.26245 20.1942 6.44405 20.3158C6.98515 20.678 7.56355 20.9888 8.1723 21.2412C9.3513 21.7301 10.6442 22 12 22Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M8.30225 9.91003H16.6919"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.9233 7.8689L9.4665 16.1311"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4233 7.8689L12.9665 16.1311"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.30225 14H15.6919"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
